<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h5 class="mt-1 mb-3">Lista de Notas Fiscais</h5>
            <TableNotas/>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/dados/app.config.json";
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import TableNotas from "@/router/views/nota_fiscal/components/table-notas";

export default {
  page: {
    title: "Notas Fiscais",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    TableNotas
  },
  data() {
    return {
      title: "Notas Fiscais",
      items: [
        {
          text: 'Painel',
          href: '/painel',
        },
        {
          text: 'Solicitações',
          active: true,
        },
      ],
    };
  },
  computed: {
    empresa: {
      get: function () {
        return this.$store.state.auth.currenEmpresa;
      },
    },
  },
  created() {
    let tipoEmpresa = parseInt(this.empresa.pes_tipopessoa);
    if (tipoEmpresa === 4) {
      this.$toast.error("Esta empresa não tem permissão para a utilização deste recurso")
      this.$router.push({name: 'painel'})
    }
  },
};
</script>

<style scoped>

</style>
